export function isFaultPromoted(
  quantityValues: { [x: string]: { measured: number } },
  filters: {
    quantityId: string;
    min: number | null;
    max: number | null;
    rule: "CONSTRAINT" | "PROMOTION";
  }[],
) {
  if (!filters || Object.keys(quantityValues).length === 0) return false;

  return filters.some(filter => {
    if (filter.rule !== "PROMOTION") return false;

    const quantityValue = quantityValues[filter.quantityId];
    if (!quantityValue) return false;

    const measuredValue = quantityValue.measured;
    const isAboveMin = filter.min === null || measuredValue >= filter.min;
    const isBelowMax = filter.max === null || measuredValue <= filter.max;

    return isAboveMin && isBelowMax;
  });
}
